// GraphQL Queries and Mutations for FCM Device Management

export const FCM_MUTATIONS = {
  REGISTER_DEVICE: `
    mutation RegisterDevice(
      $token: String!
      $platform: DevicePlatform!
      $appVersion: String
      $osVersion: String
    ) {
      registerDevice(
        token: $token
        platform: $platform
        appVersion: $appVersion
        osVersion: $osVersion
      ) {
        success
        message
        deviceId
      }
    }
  `,

  UNREGISTER_DEVICE: `
    mutation UnregisterDevice($token: String!) {
      unregisterDevice(token: $token) {
        success
        message
      }
    }
  `,

  UPDATE_DEVICE_STATUS: `
    mutation UpdateDeviceStatus(
      $token: String!
      $status: DeviceStatus!
    ) {
      updateDeviceStatus(
        token: $token
        status: $status
      ) {
        success
        message
      }
    }
  `,

  TEST_PUSH_NOTIFICATION: `
    mutation TestPushNotification(
      $token: String!
      $title: String!
      $body: String!
      $data: JSON
    ) {
      testPushNotification(
        token: $token
        title: $title
        body: $body
        data: $data
      ) {
        success
        message
      }
    }
  `
};

// Device Platform Enum values that match the GraphQL schema
export const DEVICE_PLATFORM = {
  WEB: 'WEB',
  IOS: 'IOS',
  ANDROID: 'ANDROID'
} as const;

// Device Status Enum values
export const DEVICE_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BLOCKED: 'BLOCKED'
} as const;

// Response paths for custom GraphQL client
export const FCM_RESPONSE_PATHS = {
  REGISTER_DEVICE: {
    DATA: "data.registerDevice",
    PARAMS: "",
    ERRORS: "errors"
  },
  UNREGISTER_DEVICE: {
    DATA: "data.unregisterDevice",
    PARAMS: "",
    ERRORS: "errors"
  },
  UPDATE_DEVICE_STATUS: {
    DATA: "data.updateDeviceStatus",
    PARAMS: "",
    ERRORS: "errors"
  },
  TEST_PUSH_NOTIFICATION: {
    DATA: "data.testPushNotification",
    PARAMS: "",
    ERRORS: "errors"
  }
};